<template>
  <div>
    <page-title></page-title>
    <transition name="fade" mode="out-in">
      <div v-if="cardType==='list'" class="card bg-dark" key="list">
        <div class="card-body">
          <div class="table-header">
            <form class="form">
              <div class="form-row">
                <div class="col-md-3 col-12 my-1">
                  <input v-model="search.q" type="text" class="form-control form-control mr-md-12 mr-sm-0" id="名称"
                         placeholder="名称或邮箱">
                </div>
                <div class="col-md-2 col-12 my-1">
                  <button @click="loadUser" @keyup.enter="loadUser" type="button" class="btn btn btn-primary btn-block">搜索</button>

                </div>
                <div class="col-md-2 col-12 ml-auto my-1">
                  <button type="button" @click="clickAddUser" class="btn btn btn-success  btn-block">
                    <i class="iconfont icon-c_add"></i> 添加用户
                  </button>
                </div>
              </div>

            </form>
          </div>
          <div class="table-responsive" v-if="userList&&userList.length">
            <table class="table table-leemma ">
              <thead>
              <tr>
                <th>姓名</th>
                <th>邮箱</th>
                <th>联系方式</th>
                <th>权限</th>
                <th>状态</th>
                <th>操作</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(user,index) in userList">
                <td>{{user.name}}</td>
                <td>{{user.email}}</td>
                <td>{{user.contact}}</td>
                <td>{{roleFn(user.role)}}</td>
                <td>{{user.status}}</td>
                <td>
                  <button v-if="info.role==='manager'&&(user.role!=='manager'||info.id===user.id)" @click="selectUser(index)" class="btn btn-primary btn-sm">修改信息</button>
                  <button v-if="info.role==='manager'&&(user.role!=='manager'||info.id===user.id)" @click="deleteUser(index)" class="btn  btn-outline-danger btn-sm">删除员工</button>
                </td>
              </tr>
              </tbody>
            </table>
            <page :page-size="search.pageSize" :count="search.count" :page-no="search.pageNo" @click="paging"></page>
          </div>
          <div v-else>暂无数据</div>
        </div>
      </div>
      <div v-else-if="cardType==='edit'||cardType==='add'" class="card bg-dark" key="edit">
        <div class="card-body">
          <form class="col-lg-8 col-md-10 col-sm-12">
            <div class="form-group ">
              <label>*名称</label>
              <input v-model="userInfo.name" type="text" class="form-control" placeholder="请输入名称">
            </div>
            <div class="form-group">
              <label>*角色</label>
              <select v-model="userInfo.role" class="form-control" name="" id="">

                <option v-for="role in roles" :value="role.val">{{role.label}}</option>
              </select>
            </div>

            <div class="form-group">
              <label >*邮箱</label>
              <input v-model="userInfo.email" type="email" class="form-control" aria-describedby="emailHelp"
                     placeholder="请输入邮箱">
              <small id="emailHelp" class="form-text text-muted">登陆时使用邮箱</small>
            </div>
            <div class="form-group ">
              <label>联系方式</label>
              <input v-model="userInfo.contact" type="text" class="form-control" placeholder="请输入联系方式">
            </div>
            <div class="form-group">
              <label>密码设置</label>
              <a  data-toggle="collapse" data-target="#collapseExample" aria-expanded="false" aria-controls="collapseExample">
                <i class="iconfont icon-moreunfold" style="color:#03A9F5;cursor:pointer "></i>
              </a>
              <div :class="{show:cardType==='add'}" class="collapse" id="collapseExample">
                <div class="form-group">
                  <label>密码</label>
                  <input type="password" v-model="userInfo.password" class="form-control" placeholder="请输入密码">
                </div>
                <div class="form-group">
                  <label>重复密码</label>
                  <input type="password" v-model="userInfo.password_confirmation" class="form-control"
                         placeholder="请输入密码">
                </div>
              </div>
            </div>
            <button v-if="cardType==='add'" type="button" @click="addUser" class="btn btn-primary">确定</button>
            <button v-if="cardType==='edit'" type="button" @click="editUser" class="btn btn-primary">确定</button>

            <button type="button" @click="cardType='list'" class="btn btn-link">取消</button>
          </form>
        </div>
      </div>
    </transition>
  </div>

</template>

<script>
  import pageTitle from '@/components/pageTitle'
  import {mapState} from 'vuex'
  import page from '@/components/pagination'


  export default {
    name: 'users',
    components: {
      pageTitle,
      page
    },
    data() {
      return {
        cardType: 'list',
        userList: [],
        roles: [
          {label: '请选择', val: ''},
          {label: '管理员', val: 'manager'},
          {label: '工程师', val: 'engineer'},
          {label: '业务员', val: 'employee'},
        ],
        userInfo: {
          role: '',
          contact: '',
          password: '',
          password_confirmation: '',
          email: '',
          name: '',
        },
        search: {
          q: '',
          nam: '',
          pageNo: 1,
          pageSize: 15,
          count: 1
        }
      }
    },
    computed: {
      ...mapState(
        {info: state=>state.account.info}
      )

    },
    created(){
      if(this.$route.query.type==='SELF'){
        this.selectUser('SELF')
      }
    },
    mounted() {
      this.loadUser();
      if(this.$route.query.type==='list'){
        this.cardType='list'
      }

    },
    methods: {

      clickAddUser() {
        this.userInfo = {
          role: ""
        };
        this.cardType = 'add'
      },
      addUser() {
        let url = 'users/create',
          info = this.info,
          params = {
            auth_token: 'default',
            name: this.userInfo.name,
            email: this.userInfo.email,
            password: this.userInfo.password,
            password_confirmation: this.userInfo.password_confirmation,
            role: this.userInfo.role
          };
        this.userInfo.contact ? params.contact = this.userInfo.contact : "";

        this.$http.post(url, params)
          .then(data => {
            if (data.status_code === 'SUCCEEDED') {
              this.$message.success('操作成功')
              this.loadUser();
            } else {
              this.$message.error('操作失败:'+data.msg)
            }
          })
      },
      roleFn(role){
        let name;
        for(let i =0;i< this.roles.length;i++){
          if(role === this.roles[i].val){
            name = this.roles[i].label
          }
        }
        return name
      },
      paging(no) {
        this.search.pageNo = no;
        this.loadUser()
      },
      loadUser() {
        let url = 'users',
          info = this.info,
          s = this.search,
          params = {
            auth_token: 'default',
            page_size: s.pageSize,
            page_no: s.pageNo,
            q:s.q,
            nam:s.nam
          };
        this.$http.get(url, {params})
          .then((data) => {
            if (data.status_code === 'SUCCEEDED') {
              this.userList = data.payload;
             this.search.count = data.total;
              this.cardType = 'list'
            } else {
              this.$message.error('操作失败:'+data.msg)
            }
          })
      },
      selectUser(index) {
        let user = this.userList[index];
        if(index==='SELF'){
          user = this.info
        }
        let  url = `users/${user.id}`,
          params = {
            auth_token: 'default'
          }
        this.$http.get(url, {params})
          .then(data => {
            if (data.status_code === 'SUCCEEDED') {
              this.userInfo = data.payload;
              this.cardType = 'edit';
            } else {

            }
          })

      },
      editUser() {
        let user = this.userInfo,
          url = `users/${user.id}/edit`,
          params = {
            auth_token: 'default',
            name: user.name,
            email: user.email,
            password: user.password,
            password_confirmation: user.password_confirmation,
            role: user.role,
          };
        user.role ? params.role = user.role : "";
        this.$http.patch(url, params).then(data => {
          if (data.status_code === 'SUCCEEDED') {
            this.$message.success('操作成功')
            this.loadUser();
          } else {
            this.$message.error('操作失败:'+data.msg)
          }
        })


      },
      deleteUser(index) {
        this.$confirm('确定删除用户？','提示',{    confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'}).then(() => {
          let user = this.userList[index],
            url = `users/${user.id}/destroy`,
            params = {
              auth_token: 'default',
            };
          this.$http.delete(url, {params})
            .then(data => {
              if (data.status_code === 'SUCCEEDED') {
                this.loadUser();
                this.$message.success('操作成功')
              } else {
                this.$message.error('操作失败:'+data.msg)
              }
            })
        })


      }

    }

  }
</script>

<style type="scss" scoped>
  .fade-enter-active, .fade-leave-active {
    transition: all .3s
  }

  .fade-enter {
    opacity: 0;
    transform: translateX(-5px);
  }

  .fade-leave-to {
    opacity: 0;
    transform: translateX(5px);
  }
</style>



// WEBPACK FOOTER //
// src/view/users.vue